import React from 'react';
import { Link } from 'react-router-dom';

interface LocationCTAProps {
  locationName?: string;
  className?: string;
}

const LocationCTA: React.FC<LocationCTAProps> = ({ locationName, className = '' }) => {
  return (
    <div className={`bg-white rounded-xl p-8 shadow-lg border-2 ${className}`} style={{ borderColor: '#32936F' }}>
      <div className="text-center max-w-2xl mx-auto">
        <div className="mb-6">
          <svg
            className="w-16 h-16 mx-auto"
            style={{ color: '#32936F' }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        
        <h2 className="text-2xl font-bold mb-4" style={{ color: '#023047' }}>
          {locationName 
            ? `Benötigen Sie eine Melderegisterauskunft in ${locationName}?`
            : 'Benötigen Sie eine Melderegisterauskunft?'
          }
        </h2>
        
        <p className="text-gray-600 mb-6 text-lg">
          Finden Sie schnell und sicher die aktuelle Meldeanschrift einer Person in Deutschland – 
          ohne Behördengang, 100% digital.
        </p>
        
        <Link
          to="/personal-data"
          className="inline-flex items-center justify-center px-8 py-4 rounded-md text-white shadow-md hover:shadow-xl transition-all transform hover:-translate-y-1"
          style={{
            backgroundColor: '#023047',
            fontWeight: 600,
            fontSize: '18px'
          }}
        >
          Jetzt Adresse finden
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 ml-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </Link>
        
        <div className="mt-6 flex items-center justify-center gap-2">
          <svg
            className="w-5 h-5"
            style={{ color: '#32936F' }}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <span className="text-gray-600 font-medium">
            Über 200 erfolgreiche Auskünfte in den letzten 30 Tagen
          </span>
        </div>
      </div>
    </div>
  );
};

export default LocationCTA;

